import http from "services/httpService";
import * as Yup from "yup";

export const PRODUCT_PRICING_VALUES = {
  insurer: "",
  pricingFile: "",
  other_details: [""]
};

export const insurerValidationSchema = Yup.object().shape({
  insurer: Yup.string().required("*Required"),
});

export const fetchUniversalSetupMasterSelected = async () => {
  try {
    const { data } = await http.get("business/userplans_data_selected/");
    if (data) {
      localStorage.setItem("eb_selected_values", JSON.stringify(data));
    }
  } catch (err) {
    console.log(err);
  }
};
